import styled from 'styled-components';
import Text14 from '@sdk/components/ui/typography/Text14';

const getWrapperLayout = (withCheckbox = false) => {
  let areas = 'info meta actions';
  let sizes = ' 1fr min-content 40px';

  if (withCheckbox) {
    areas = 'checkbox ' + areas;
    sizes = 'min-content ' + sizes;
  }

  return `"${areas}" / ${sizes}`;
};

export const CheckboxWrapper = styled.div`
  grid-area: checkbox;
`;

type Props = {
  isManageable?: boolean;
  isSelected?: boolean;
};
export const Wrapper = styled.div<Props>`
  all: unset;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  display: grid;
  gap: 10px;
  grid-template: ${({ isManageable, isSelected }) => getWrapperLayout(isManageable && isSelected)};
  min-height: 60px;
  padding: 10px 20px;
  transition: background-color 0.125s ease;
  width: 100%;

  &:hover {
    grid-template: ${({ isManageable }) => getWrapperLayout(isManageable)};
  }

  & ${CheckboxWrapper} {
    display: ${({ isManageable, isSelected }) => (isManageable && isSelected ? 'unset' : 'none')};
  }

  &:hover ${CheckboxWrapper} {
    display: ${({ isManageable }) => (isManageable ? 'unset' : 'none')};
  }
`;

export const Info = styled.div`
  grid-area: info;
`;

export const Title = styled(Text14)`
  color: ${({ theme }) => theme.colors.gray};
  display: block;
  margin: 0;
  max-width: 635px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const Author = styled.p`
  margin: 0;
`;

export const Meta = styled.ul`
  all: unset;
  display: flex;
  flex-flow: row wrap;
  grid-area: meta;
  justify-content: flex-end;
  list-style: none;
  place-self: end;
  width: min-content;

  li {
    margin-left: 10px;
  }

  & > li:last-of-type {
    width: max-content;
  }

  svg {
    margin-right: 5px;
    vertical-align: text-bottom;
  }
`;

export const ViewsButton = styled.button`
  all: unset;
  cursor: pointer;
  transition: color 0.125s ease;

  svg {
    color: ${({ theme }) => theme.colors.iconGray};
  }

  &:hover,
  &:hover svg {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const Actions = styled.div`
  grid-area: actions;
`;
